export default {
    data () {
        return{

        }
    },
    filters: {
        // 油种类样式
        oilModelFormat (model) {
            let gasolineModelArr = ['90#', '92#', '93#', '95#', '97#', '100#']
            let dieselModelArr = ['10#', '5#', '0#', '-5#', '-10#', '-21#', '-35#']
            let styleArr = ['#ed6a0c', '#ff976a', '#07c160']
            // 汽油种类使用第一种颜色，柴油种类使用第二种颜色，其他种类使用第三种
            // indexOf()未查找到返回-1故+1
            return (gasolineModelArr.indexOf(model)+1 && styleArr[0])
                || (dieselModelArr.indexOf(model)+1 && styleArr[1])
                || styleArr[2]
        },
        // 油名称样式
        oilNameFormat (name) {
            let nameArr = ['汽油', '柴油', '清洁汽油']
            let styleArr = ['#576b95', '#969799', '#3388ff', '#ad0000']
            // 各名称搭配不同颜色，其他为最后一种
            return styleArr[nameArr.indexOf(name)] || styleArr[3]
        }
    },
    computed: {
        // 油卡类型
        cardType () {
            return (key) => {
                // 判断数据是否加载完
                if (!key) return
                return this.$store.state.systemEnum.card_type[key].name
            }
        },
        // 订单状态
        orderState () {
            return (key) => {
                if (!key) return
                return this.$store.state.systemEnum.company.user_order.status[key]
            }
        },
        // 支付方式
        paymentMethod () {
            return (key) => {
                if (!key) return
                return this.$store.state.systemEnum.company.user_order.payment_method[key]
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/mixin.js